<template>
  <div>
    <router-view
      v-if="item.id"
      :item="item"
      :item_saved="item_saved"
      @update="update"
    />
  </div>
</template>
<script>
import {updateMixin} from '@/components/mixins/Update'
import PageTabs from '@/components/helpers/Layout/PageTabs'
import { formUrl } from '@/config/config'
import ExternalFormCreate from './ExternalFormCreate'
import moment from 'moment'
import Ui from '@/classes/Ui'
import languages from '@/config/data/languages'
import {diff} from 'deep-object-diff'
import { EventBus } from '@/EventBus.js'
import Api from '@/api/ExternalForm.js'

let tabs = [
  {name: 'external_form_editor'},
  {name: 'external_form_options'},
  {name: 'external_form_preview'}
]
export default {
  mixins: [updateMixin],
  data(){
    return {
      tabs,
      api: new Api(),
      model: "external_forms",
      item_saved: {},
      languages: languages,
    }
  },
  components: {
    ExternalFormCreate,
    PageTabs,
  },
  props: ['language'],
  computed: {
    currentTab(){
      return this.$store.state.active_tab || 'editor'
    },
    unpublishedChanges() {
      // Diff the unpublished and published changes
      // I tried to clean this code up a little by combining the two loops
      // but it didn't work and I am in a rush :)
      if (!this.item || !this.item.structure || !this.item.unpublished_structure) {
        return 0
      }
      return this.generateDiffLength()
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('RESET_DRAG_EDITOR')
    this.$store.commit('SET_HEADER_COMPRESSED', false)
    next()
  },
  beforeRouteUpdate(to, from, next) {
    // necessary as otherwise the redirect in created() would trigger again
    if (to.name === 'external_form_edit') {
      this.$router.push({
        name: 'external_forms'
      })
    }
    this.$store.commit('SET_ACTIVE_TAB', to.name)
    next()
  },
  created() {
    // Navigate to editor directly
    if (this.$route.name === 'external_form_edit') {
      this.$router.push({
        name: 'external_form_editor'
      })
    }
  },
  mounted () {
    this.$store.commit('SET_ACTIVE_TAB', this.tabs[0].name)
    this.$store.commit('SET_HEADER_COMPRESSED', true)
    Ui.setSecondaryHeaderTabs(this.tabs)
    Ui.setPageLevel(3)
    Ui.setSubtitle({link: {name: 'external_forms'}})
    if(!this.item.configuration){
      this.item.configuration = {}
    }
  },
  beforeDestroy(){
    this.$store.commit('EMPTY_TABS')
    this.$store.commit('EMPTY_NOTIFICATION')
    this.$store.commit('SET_SECONDARY_HEADER_TABS', [])
    window.removeEventListener('onbeforeunload',function(){})
  },
  methods: {
    generateDiffLength() {
      let clonedStructure = _.cloneDeep(this.item.structure)
      let clonedUnpublishedStructure = _.cloneDeep(this.item.unpublished_structure)
      let diffObj = diff(clonedStructure, clonedUnpublishedStructure)
      return Object.keys(diffObj).length
    },
    afterRetrieve(){
      this.item_saved = _.clone(this.item)
    },
    isDisabled() {
      if (this.value.actions.board_businesskit.status === 'disabled') {
        this.value.actions.board_businesskit.send_directly = false
        return true
      }
      return false
    },
    update(item) {
      if (!item) {
        item = this.item
      }
      this.api.post(item).then((item) => {
        this.item = item
        this.item_saved = _.clone(item)
        this.errors = []
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'models.' + this.singular_model + '.message.' + this.type,
          'type': 'success'
        })
        EventBus.$emit('external_form_update', this.item)
      }).catch((e) => {
        this.errors = e.response.data.errors
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'errors.' + e.response.data.errors[0].code,
          'type': 'error'
        })
      })
    },
  },
  watch: {
    unpublishedChanges(val) {
      this.$store.commit('SET_DRAG_EDITOR_UNPUBLISHED_CHANGES', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.page-saver-wrapper {
  margin-top: 15px;
}
.max-width {
  max-width: 460px;
}
.optional{
    display: none!important;
  }
.external-form-update{
  margin: 0px;
  .alwaysHidden{
   display: none;
  }
  .lead-mask-raw{
    margin-bottom: 24px;
    margin-top: 16px;
    .lead-mask-raw--title{
      font-size: 16px;
      color: #333;
      cursor: pointer;
      .icon{
        vertical-align: middle;
      }
    }
    .lead-mask-raw--content{
      padding: 10px;
      border: 1px solid #c9c9c9;
    }
  }
  #form-tabs {
    border-bottom: 0;
    background: $pastel-lighter;
    margin-top: -20px;
    margin-left: -20px;
    margin-right: -20px;
    padding: 0 0px;
    display: flex;
    overflow-x: auto;
    height: 50px;
    .tab{
      padding: 20px;
      color: $pastel-dark;
      cursor: pointer;
      margin: 0 5px;
      font-size: 1.1em;
      &:first-child{
        margin-left: 0;
      }
      &.is-active{
        color: $onyx-light;
        padding-bottom: 5px;
        border: 0;
        background-color: #fff;
        border-radius: 4px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
  h4{
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
    font-weight: 400;
    padding: 1.5em 0 1em;
    color: $onyx;
    &:first-child{
      margin-top: 0;
    }
  }
  h5{
    font-size: 16px;
    margin-top: 15px;
    margin-bottom: 5px;
    font-weight: 400;
    color: $onyx;
    padding: 1em 0;
    &:first-child{
      margin-top: 0;
    }
  }
  h6{
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 5px;
    font-weight: 400;
    color: $onyx;
    &:first-child{
      margin-top: 0;
    }
  }
  .input--select-wrapper:after{
    line-height: 1em;
    height: 1em;
  }
  .is-inline{
    .field--input,
    .field-select{
      min-width: 200px;
    }
  }
  .form-switch{
    display: flex;
    justify-content: space-between;
    label{
      font-size: 1em;
      font-weight: 200;
    }
  }
  .is-inline label{
    display: inline-block;
    align-self: center;
    margin-right: 10px;
    margin-top: 0;
    min-width: 150px;
  }
  label .optional{
    display: none;
  }
  .mailchimp-fields{
    .is-inline{
      .field--input,
      .field-select,
      label{
        min-width: auto;
      }
    }
  }
  .preview-zone{
    text-align: center;
    iframe{
      width: 0;
      height: 0;
      &.is-active{
        width: 100%;
        min-height: 400px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
}
.tab--container{
  margin-bottom: 20px;
}
textarea#structure{
  min-height: 10em;
}

</style>



// WEBPACK FOOTER //
// ExternalFormUpdate.vue?3a8270e8